import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { EventsService } from 'src/app/services/events.service';
import { Subscription } from 'rxjs';
import { EventVM } from 'src/app/models/event/event';
import { PlatformHeadrId, SiteViewConfiguration, StreamType } from 'src/app/models/enums';
import { UtilityService } from 'src/app/services/util/utility.service';
import { DeployParams } from 'src/app/deployParams';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
declare var SIR: any;

@Component({
  selector: 'app-streaming-wrap',
  templateUrl: './streaming-wrap.component.html',
  styleUrls: ['./streaming-wrap.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class StreamingWrapComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  // ovo ce biti link kad dobijemo od API-ja - for later
  liveStreamUrl: string = null;
  streamingEventBetradarEventId: number;
  streamingEventLiveStreamId: number;
  showStreamingComponent: boolean;
  isUserLoggedIn = false;
  isMobileView: boolean;
  isWidgetActive = true;
  sportId: number;

  @Input()
  isWidgetFullSize: boolean;

  constructor(private eventsService: EventsService, private utilityService: UtilityService, private userService: UserService) {
    this.isMobileView = utilityService.mobileView;
    this.subscription.add(this.eventsService.showStream$.subscribe((x) => {
      if (this.userService.user.userSBToken || environment.localDeploy) {
        this.isUserLoggedIn = true;
      }else{
        this.isUserLoggedIn = false;
      }

      if (this.streamingEventBetradarEventId === x.betRadarEventId && this.showStreamingComponent) {
        this.showStreamingComponent = false;

        //  check if widget removed to destroy widget instance
        setTimeout(() => {
          SIR('check');
        }, 800);
      } else {
        const interval = setInterval(() => { this.setContentPosition(interval); }, 100);
        this.showStreamingComponent = x.showStream;
      }

      this.streamingEventBetradarEventId = x.betRadarEventId;
      this.streamingEventLiveStreamId = x.liveStreamId;
      this.sportId = x.sportId;


      if (this.streamingEventLiveStreamId && this.isUserLoggedIn){
        this.eventsService.getLiveStreamUrl(this.streamingEventBetradarEventId, StreamType.HlsManifest).subscribe(res => {
          this.liveStreamUrl = res;
          this.isWidgetActive = false;
        });
      }

      if (!this.streamingEventLiveStreamId || !this.isUserLoggedIn) {
        this.isWidgetActive = true;
      }

      // if (this.eventsService.expandEvent) {
      //   console.log('expanded');
      // }

    }));
  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }

  ngOnInit(): void {}

  setContentPosition(interval) {
    if (document.getElementById('streamingWrap') === null || window.parent.innerWidth > 1600) { return; }
    const streamingWrap = document.getElementById('streamingWrap');
    // let scrollTop = environment.localDeploy ? 0 : window.parent.scrollY;
    const scrollTop = 0;
    // const scrollTop = environment.localDeploy ? 0 : window.parent.document.getElementById('container').scrollTop;
    const windowHeight = window.parent.innerHeight;
    const documentHeight = document.body.clientHeight;

    setTimeout(() => {
      const interval = setInterval(() => {
        if (streamingWrap.offsetHeight > 150) {
          if (windowHeight + scrollTop < documentHeight ) {
            const top = windowHeight - streamingWrap.offsetHeight + scrollTop - 70;
            streamingWrap.style.transform = 'translate(0px, ' + top + 'px)';
          } else {
            const top = documentHeight - streamingWrap.offsetHeight - 70;
            streamingWrap.style.transform = 'translate(0px, ' + top + 'px)';
          }

          if (document.querySelector('.lmt-container .srm-fullyloaded')){
            clearInterval(interval);
          }
        }
      }, 300);

    }, 500);

    clearInterval(interval);
  }

  switchWidgetAndLiveStream(widget: boolean): void {
    if (widget !== this.isWidgetActive) {
      this.isWidgetActive = widget;
    }
  }

  close() {
    this.showStreamingComponent = false;
  }

  ngOnDestroy(): void{
    this.subscription.unsubscribe();
  }

}
